/**
 * Constants for UserPage and child components
 */

// History pagination
export const DEFAULT_HISTORY_PAGE_SIZE = 20
export const HISTORY_LOAD_MORE_INCREMENT = 20

// Accordion styling
export const ACCORDION_BORDER_STYLE = {
  border: '1px',
  borderColor: 'gray.200',
  borderRadius: 'md',
  bg: 'white',
} as const

export const ACCORDION_BUTTON_STYLE = {
  px: 3,
  py: 2,
  _hover: { bg: 'gray.50' },
  borderRadius: 'md',
} as const
